import { useExchangeRates } from '../ExchangeRatesProvider'

interface CurrencySelectProps {
  className?: string
  currencies: string[]
}

const CurrencySelect = ({
  className = '',
  currencies,
}: CurrencySelectProps) => {
  const { currency: value, setCurrency } = useExchangeRates()

  return (
    <select
      className={className}
      name="currency-picker"
      value={value}
      onChange={(e) => {
        setCurrency(e.target.value)
      }}
    >
      {currencies.map((currency) => (
        <option key={currency} value={currency}>
          {currency}
        </option>
      ))}
    </select>
  )
}

export default CurrencySelect
